module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-25-1f21e32850c1a7f3df69151bc43d91b1.svg";